import api from '../../../../api';
import { UpdateProfileProgressPayload } from '../../../types/user-setting';

const updateProfileProgress = async (payload: UpdateProfileProgressPayload) =>
  api.patch('/user/profile/progress', payload);

export default updateProfileProgress;
